const ImgOk = () => (
    <img width={60} src={require('./ok.svg').default} alt='imagen' />
);

const ImgError = () => (
    <img width={60} src={require('./error.svg').default} alt='imagen' />
);

const ImgInfo = () => (
    <img width={15} src={require('./info.png').default} alt='imagen' />
);

const ImgUser = () => (
    <img width={60} src={require('./user.svg').default} alt='imagen' />
);

export { ImgOk, ImgError, ImgInfo, ImgUser }